/* eslint-disable no-param-reassign */
import produce from "immer";
import {
  SEARCH_NOTIFICATIONS_REQUEST,
  SEARCH_NOTIFICATIONS_SUCCESS,
  SEARCH_NOTIFICATIONS_FAILURE,
  GET_NOTIFICATIONS_CONTENT_REPLACE_REQUEST,
  GET_NOTIFICATIONS_CONTENT_REPLACE_SUCCESS,
  GET_NOTIFICATIONS_CONTENT_REPLACE_FAILURE,
  GET_LIST_NOTIFICATION_MESSAGE_REQUEST,
  GET_LIST_NOTIFICATION_MESSAGE_SUCCESS,
  GET_LIST_NOTIFICATION_MESSAGE_FAILURE,
  GET_ONE_NOTIFICATION_MESSAGE_REQUEST,
  GET_ONE_NOTIFICATION_MESSAGE_SUCCESS,
  GET_ONE_NOTIFICATION_MESSAGE_FAILURE,
  CLEAR_NOTIFICATION_MESSAGE,
  GET_LIST_NOTIFICATION_HISTORY_MESSAGE_REQUEST,
  GET_LIST_NOTIFICATION_HISTORY_MESSAGE_SUCCESS,
  GET_LIST_NOTIFICATION_HISTORY_MESSAGE_FAILURE
} from "src/actions/notificationsActions";

const initialState = {
  notifications: [],
  total: 0,
  contentReplace: [],
  notificationMessage: [],
  totalMessage: 0,
  notificationHistoryMessage: [],
  totalHistoryMessage: 0,
  detailNotification: null,
  loading: false
};

const notificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SEARCH_NOTIFICATIONS_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case SEARCH_NOTIFICATIONS_SUCCESS: {
      const {response, total} = action.payload;
      return produce(state, (draft) => {
        draft.notifications = response;
        draft.loading = false;
        draft.total = total;
      });
    }

    case SEARCH_NOTIFICATIONS_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case GET_NOTIFICATIONS_CONTENT_REPLACE_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case GET_NOTIFICATIONS_CONTENT_REPLACE_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.contentReplace = response;
        draft.loading = false;
      });
    }

    case GET_NOTIFICATIONS_CONTENT_REPLACE_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    // send all message
    case GET_LIST_NOTIFICATION_MESSAGE_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case GET_LIST_NOTIFICATION_MESSAGE_SUCCESS: {
      const {response, total} = action.payload;
      return produce(state, (draft) => {
        draft.notificationMessage = response;
        draft.loading = false;
        draft.totalMessage = +total;
      });
    }

    case GET_LIST_NOTIFICATION_MESSAGE_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case GET_ONE_NOTIFICATION_MESSAGE_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case GET_ONE_NOTIFICATION_MESSAGE_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.detailNotification = response;
        draft.loading = false;
      });
    }

    case GET_ONE_NOTIFICATION_MESSAGE_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case CLEAR_NOTIFICATION_MESSAGE: {
      return produce(state, (draft) => {
        draft.detailNotification = null;
      });
    }

    case GET_LIST_NOTIFICATION_HISTORY_MESSAGE_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case GET_LIST_NOTIFICATION_HISTORY_MESSAGE_SUCCESS: {
      const {response, total} = action.payload;
      return produce(state, (draft) => {
        draft.notificationHistoryMessage = response;
        draft.loading = false;
        draft.totalHistoryMessage = +total;
      });
    }

    case GET_LIST_NOTIFICATION_HISTORY_MESSAGE_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    default: {
      return state;
    }
  }
};

export default notificationsReducer;
